// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JLWk","comment":"styles_comment__3YU3v"};